import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { XeroObjectDataset } from 'app/model/dataset/xero.dataset';
import { XeroLinkedService } from 'app/model/linkedservice/xero.linkedservice';
import { format } from 'app/shared/utils/string.util';

export const xeroObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(XeroObjectDataset).name,
    displayName: stringResources.Xero_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(XeroLinkedService).name],
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
        stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
        stringResources.VersionLabel.toLocaleLowerCase()),
    warningMessageHyperlink: 'https://learn.microsoft.com/azure/data-factory/connector-xero',
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-xero'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps'],
    isTableNameRequired: '{ linkedService && linkedService.version === "v2" }',
    notSupportCopySourceQuery: '{ linkedService && linkedService.version === "v2" }',
    tableNameDisplay: 'Table',
};
